import styled from 'styled-components';
import { Modal } from 'antd';

export const ModalWrapper = styled(Modal)`
	.ant-modal-content {
		border-radius: 30px;
		padding: 2rem 3rem;
		height: fit-content;
	}

	.ant-modal-header {
		border-bottom: none;
		.ant-modal-title {
			font-size: 24px;
			font-weight: 600;
		}
	}

	.ant-modal-footer {
		display: flex;
		justify-content: center;
		gap: 1rem;
		width: 100%;
		align-items: center;
	}

	.ant-modal-body {
		overflow-y: auto;
	}
`;

export const ActionPlanModalFooter = styled.div`
	display: flex;
	justify-content: center;
	gap: 1rem;
	width: 100%;
	align-items: center;
`;
